module.exports = __webpack_public_path__ + "static/pink2-da28e18c21d5c7180fb4790a3399b95b.png";